import { IconProp } from '@fortawesome/fontawesome-svg-core';
import React from 'react';
import { ModalHeader as MdlHeader, ModalHeaderProps } from 'react-bootstrap';
import CircledIcon, { CircledIconVariant, TooltipPos } from '../CircledIcon';

export type customModalHeaderProps = ModalHeaderProps &
  React.PropsWithChildren<{
    leftIcon?: IconProp;
    leftIconVariant?: CircledIconVariant;
    leftIconTooltipText?: string;
    leftIconTooltipPos?: TooltipPos;
    rightButton?: React.ReactNode;
    rightIconLabel?: string;
    withBorder?: boolean;
  }>;

const ModalHeader = ({
  closeButton,
  leftIcon,
  leftIconVariant,
  leftIconTooltipText,
  leftIconTooltipPos,
  rightButton,
  rightIconLabel,
  withBorder,
  children,
  ...props
}: customModalHeaderProps) => {
  return (
    <MdlHeader
      closeButton={closeButton}
      {...props}
      className={withBorder ? '' : 'no-border'}
    >
      <div className={'title-holder '}>
        {leftIcon && (
          <CircledIcon
            icon={leftIcon}
            iconClassName="left-icon"
            variant={leftIconVariant}
            tooltipText={leftIconTooltipText}
            tooltipPos={leftIconTooltipPos}
          />
        )}
        {children}
      </div>
      {rightButton}
    </MdlHeader>
  );
};

export default ModalHeader;
